/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { TextInput, useDataProvider, useRecordContext } from 'react-admin';
import { useForm } from 'react-hook-form';
import FormCard from '../FormCard';
import { useGetTeacherCurriculum, useTranslation } from 'hooks';

const i18nPath = 'resources.platform_users.tabs.teacherData.curriculum';

const Curriculum = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const { data } = useGetTeacherCurriculum(record?.teacherId);

  const methods = useForm({
    defaultValues: {
      curriculum: '',
    },
  });

  useEffect(() => {
    const { reset } = methods;
    reset(data);
  }, [data]);

  const handleSubmit = async (data) => {
    await dataProvider.updateTeacherCurriculum(record.teacherId, data);
  };
  return (
    <FormCard
      title={useTranslation(i18nPath, 'title')}
      methods={methods}
      onSubmit={handleSubmit}
    >
      <TextInput label={false} source='curriculum' multiline fullWidth />
    </FormCard>
  );
};

export default Curriculum;
